import { useIntl } from '@weenat/wintl';
import isNil from 'lodash-es/isNil';
import moment from 'moment-timezone';
import { useClient } from '../ClientProvider';
import { getWeatherModelsInPeriod } from '../core/forecasts';
import { timestampToMoment } from '../core/history/datesUtilities';
import { getAggregateValue } from '../core/summary';
import TimeSteps from '../enums/TimeSteps';
import useQuery from '../useQuery';
import useConvertedValue from './useConvertedValue';
const metricsToFetch = ['FF', 'U', 'DD', 'CLDC'];
const useFrostWeatherConditions = ({ plot, plotSummary }) => {
    const client = useClient();
    const { convertValue } = useConvertedValue();
    const { t } = useIntl();
    const { timezone, location } = plot;
    const since = moment().tz(timezone).startOf('hour').unix();
    const before = moment().tz(timezone).startOf('hour').add(1, 'hours').unix();
    // Get the next hour prevision
    const forecasts = useQuery(client.forecasts.getForecasts({
        plotId: plot.id,
        since,
        before,
        span: TimeSteps.perHours,
        metrics: metricsToFetch
    })).data;
    const lng = location?.coordinates[0];
    const lat = location?.coordinates[1];
    const weatherModelsTimeFrames = useQuery(client.forecasts.getWeatherModel({ lat: lat, lng: lng }), {
        enabled: !isNil(location)
    }).data;
    const forecastModels = getWeatherModelsInPeriod({ start: since, end: before }, weatherModelsTimeFrames);
    const summaryHumidity = getAggregateValue('U', 'latest', plotSummary.data);
    const summaryWind = getAggregateValue('FF', 'latest', plotSummary.data);
    const summaryWindDir = { value: plotSummary.data.DD, timestamp: summaryWind.timestamp };
    const summarySunrise = {
        value: !isNil(plotSummary.metadata.sunrise)
            ? timestampToMoment(plotSummary.metadata.sunrise).format(t('formats.time'))
            : null
    };
    let humidity = {
        ...summaryHumidity,
        forecastModels: [],
        value: convertValue({ metric: 'U', displayUnit: true, value: summaryHumidity.value })
    };
    let wind = {
        ...summaryWind,
        forecastModels: [],
        value: convertValue({ metric: 'FF', displayUnit: true, value: summaryWind.value })
    };
    const [cloudCoverTs, cloudCoverValue] = !isNil(forecasts?.CLDC)
        ? Object.entries(forecasts?.CLDC || [])[0]
        : [];
    const cloudCover = {
        value: convertValue({ metric: 'CLDC', displayUnit: true, value: cloudCoverValue }),
        timestamp: cloudCoverTs,
        forecastModels
    };
    let windDir = summaryWindDir;
    if (!isNil(forecasts)) {
        if (isNil(summaryHumidity.value)) {
            const [forecastHumidityTs, forecastHumidityValue] = Object.entries(forecasts?.U || [])[0];
            humidity = {
                forecastModels,
                timestamp: forecastHumidityTs,
                value: convertValue({ metric: 'U', displayUnit: true, value: forecastHumidityValue })
            };
        }
        if (isNil(summaryWind.value)) {
            const [windHumidityTs, windHumidityValue] = Object.entries(forecasts?.FF || [])[0];
            const [windDirHumidityTs, windDirHumidityValue] = Object.entries(forecasts?.DD || [])[0];
            wind = {
                forecastModels,
                timestamp: windHumidityTs,
                value: convertValue({ metric: 'FF', displayUnit: true, value: windHumidityValue })
            };
            windDir = {
                timestamp: windDirHumidityTs,
                value: windDirHumidityValue
            };
        }
    }
    return {
        humidity,
        wind,
        windDir,
        sunrise: summarySunrise,
        cloudCover
    };
};
export default useFrostWeatherConditions;
